import React from "react";

import { SimpleModal } from "@/services/simple-modal/simple-modal";

interface ModalProviderProps {
    children: React.ReactNode;
}

/**
 * Mounts the simple modal component (`confirmModal` / `infoModal`). Feature modals stay local
 */
export function ModalProvider({ children }: ModalProviderProps) {
    return (
        <>
            {children}
            <SimpleModal />
        </>
    );
}
